export default __webpack_public_path__ + "static/img7-e011c113ee9f27400b42ba7cfe071ef7.jpg";